<template>
    <b-card
        class="store-card"
        :no-body="noBody"
        bg-variant="white" v-if="checkIsReturnToStore()">
        <p>
            <strong>
                {{ selectedStoreName() }}
            </strong>
        </p>
        <span class="prod-det">
            {{ $t('common.city') }} {{ selectedStoreConfig().address.city }}<br>
            {{ $t('common.street') }} {{ selectedStoreConfig().address.street }}<br>
            {{ $t('common.phone') }} {{ selectedStoreConfig().address.phone }}
        </span>
    </b-card>
</template>
<script>
export default {
    props: {
        noBody: {
            required: false,
            default: false,
        },
        checkIsReturnToStore: {},
        selectedStoreConfig: {},
        selectedStoreName: {}
    }
}
</script>
<style scoped>
.store-card {
    line-height: 1.1;
}
</style>
